import { render, staticRenderFns } from "./notification-cookie.vue?vue&type=template&id=79a642ad&scoped=true"
import script from "./notification-cookie.vue?vue&type=script&lang=js"
export * from "./notification-cookie.vue?vue&type=script&lang=js"
import style0 from "./notification-cookie.vue?vue&type=style&index=0&id=79a642ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a642ad",
  null
  
)

export default component.exports